import {
  Directive,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';
import { Subscription } from 'rxjs';


/**
 * Directive to collapse a drawer panel
 * classContainer: selector class of the container element
 */
@Directive({
  selector: '[SheetBottom]',
  providers: [DrawerPanelService],
})
export class SheetBottomDirective implements OnInit, OnDestroy {
  @Input() classContainer: string | undefined;
  @Input() _breakPoint: number[] | undefined = [0.08, 0.5, 0.8];
  @Input() initialSize = '55px';
  @Input() _breakPointIndex = -1;

  @Input() 
  set breakPoint(value: number[] | undefined) {
    if (value !== undefined) {
      this._breakPoint = value;
    }
  }
  
  get breakPoint() {
    return this._breakPoint || [0.08, 0.5, 0.8];
  }

  elementHeight: number | undefined;
  maxWidth = 960;
  startingPosition = 0;

  private collapseDrawerSubscription: Subscription;

  constructor(
    private drawerPanelService: DrawerPanelService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.collapseDrawerSubscription = this.drawerPanelService.collapseDrawer$.subscribe(this.collapseDrawer);
  }

  ngOnDestroy(): void {
    this.collapseDrawerSubscription.unsubscribe();
  }

  private getContainerElement(): HTMLElement | null {
    return document.querySelector(`.${this.classContainer}`);
  }

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    if (this.maxWidth < document.documentElement.clientWidth) return;

    if (this.startingPosition === 0) {
      this.startingPosition = $event.clientY;
      this.elementHeight = document.documentElement.clientHeight;
    }

    this._breakPointIndex = (this._breakPointIndex + 1) % this._breakPoint.length;

    const containerEl = this.getContainerElement();
    if (containerEl && this.elementHeight !== undefined && this._breakPointIndex === 0) {
      this.renderer.setStyle(containerEl, 'height', this.initialSize);
    }

    if (this.elementHeight !== undefined && this._breakPointIndex !== 0) {
      this.renderer.setStyle(containerEl, "height", `${this.elementHeight * this._breakPoint[this._breakPointIndex]}px`);
      this.renderer.setStyle(containerEl, "max-height", `${this.elementHeight * this._breakPoint[this._breakPointIndex]}px`);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize($event: UIEvent) {
    const media = window.matchMedia('(max-width:' + this.maxWidth + 'px)');
    !media.matches && this.renderer.removeStyle(this.getContainerElement(), 'height');
  }

  collapseDrawer(collapse: boolean) {
    if (!collapse) return;

    if (this.maxWidth < document.documentElement.clientWidth) return;

    this.startingPosition = document.documentElement.clientHeight;
    this.elementHeight    = document.documentElement.clientHeight;
    this._breakPointIndex  = 0;

    if (this.elementHeight !== undefined) {
      this.renderer.setStyle(this.getContainerElement(), "height", this.initialSize);
      this.drawerPanelService.collapseDrawer(false);
    }
  }
}